import { render, staticRenderFns } from "./LoadMore.vue?vue&type=template&id=27356d4a&scoped=true&"
import script from "./LoadMore.vue?vue&type=script&lang=ts&"
export * from "./LoadMore.vue?vue&type=script&lang=ts&"
import style0 from "./LoadMore.vue?vue&type=style&index=0&id=27356d4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27356d4a",
  null
  
)

export default component.exports